import React from "react";

const MealShimmer = () => {
  return (
    <>
      <div className="flex flex-col w-[90%] md:w-[80%] mx-auto mt-8">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 mx-auto justify-items-center">
          {Array.from({ length: 5 }).map((_, index) => (
            <div
              key={index}
              className="flex flex-col overflow-hidden cursor-pointer animate-pulse"
            >
              {/* Image Placeholder */}
              <div className="w-full xl:w-64 aspect-square rounded-xl bg-gray-300 mb-2"></div>

              {/* Text Placeholder */}
              <div className="p-1 flex flex-col gap-2">
                <div className="h-5 bg-gray-300 rounded w-3/4"></div>
                <div className="h-4 bg-gray-300 rounded w-1/2"></div>

                {/* Days Placeholder */}
                <div className="flex gap-1 mb-1 mt-2">
                  {Array.from({ length: 7 }).map((_, dayIndex) => (
                    <span
                      key={dayIndex}
                      className="w-[18px] h-[18px] md:w-6 md:h-6 bg-gray-300 rounded-md"
                    ></span>
                  ))}
                </div>

                {/* Lunch/Dinner dots */}
                <div className="flex items-center gap-4 mb-1">
                  <div className="flex items-center gap-1">
                    <span className="w-3 h-3 rounded-full bg-gray-300"></span>
                    <span className="h-3 bg-gray-300 rounded w-10"></span>
                  </div>
                  <div className="flex items-center gap-1">
                    <span className="w-3 h-3 rounded-full bg-gray-300"></span>
                    <span className="h-3 bg-gray-300 rounded w-10"></span>
                  </div>
                </div>

                {/* Description Placeholder */}
                <div className="h-3 bg-gray-300 rounded w-full"></div>
                <div className="h-3 bg-gray-300 rounded w-5/6"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MealShimmer;


